export const RULE_TYPES = [
  { value: "logo_usage", label: "Logo Usage", tier: 2 },
  { value: "color_usage", label: "Color Usage", tier: 2 },
  { value: "typography_usage", label: "Typography Usage", tier: 2 },
  { value: "punctuation_style", label: "Punctuation Style", tier: 1 },
  { value: "required_element_presence", label: "Required Element Presence", tier: 1 },
  { value: "prohibited_element", label: "Prohibited Element", tier: 2 },
  { value: "prohibited_claim_or_phrase", label: "Prohibited Claim or Phrase", tier: 2 },
  { value: "required_disclaimer", label: "Required Disclaimer or Legal Copy", tier: 1 },
  { value: "offer_constraint", label: "Offer Constraint", tier: 1 },
  { value: "location_data_accuracy", label: "Location Data Accuracy", tier: 1 },
  { value: "asset_eligibility", label: "Asset Eligibility", tier: 1 },
  { value: "image_restriction", label: "Image Restriction", tier: 1 },
  { value: "postal_zone_integrity", label: "Postal Zone Integrity", tier: 1 },
  { value: "print_production_constraint", label: "Print Production Constraint", tier: 1 },
  { value: "permission_boundary", label: "Permission Boundary", tier: 1 },
  { value: "brand_note", label: "Brand Note (advisory)", tier: 1 },
];

export const SEVERITIES = [
  { value: "mandatory", label: "Mandatory" },
  { value: "approval_required", label: "Approval Required" },
  { value: "strong_preference", label: "Strong Preference" },
  { value: "recommendation", label: "Recommendation" },
  { value: "informational", label: "Informational" },
];

export const SEVERITY_BLURBS = {
  mandatory:
    "Must hold. Generation, edits, approval, and export are all blocked by violations.",
  approval_required:
    "Allowed only with explicit Approver acknowledgement before export.",
  strong_preference:
    "Preferred; violations are flagged but do not block approval or export.",
  recommendation: "Surfaced as informational guidance only.",
  informational: "Visible context; never blocks.",
};

export const PANELS = ["front", "back", "interior_left", "interior_right", "interior_top", "mailing"];

export const LIFECYCLE_LABELS = {
  draft: "Draft",
  active: "Active",
  retired: "Retired",
};

export const ruleTypeLabel = (v) =>
  RULE_TYPES.find((t) => t.value === v)?.label || v;
export const severityLabel = (v) =>
  SEVERITIES.find((s) => s.value === v)?.label || v;
